<template>
  <span class="labeled-status-badge">
    <span class="labeled-status-badge__label">{{ label }}:</span>
    <b-badge
      pill
      class="labeled-status-badge__value"
      :class="`labeled-status-badge__value--${variant}`"
    >
      {{ value }}
    </b-badge>
  </span>
</template>

<script>
// Shared "Label: Value" status readout for CandidateCard (Compliance,
// Resume). Colours match the approval-status pill convention used elsewhere
// in the app (see CompanyApprovalBadge.vue on company tradie lists) rather
// than the brighter file-valid/invalid palette (`.badge-hovered`) — that one
// is reserved for raw file status, not general approval-style badges.
export default {
  name: 'LabeledStatusBadge',

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    // success | warning | danger | secondary
    variant: {
      type: String,
      default: 'secondary',
    },
  },
}
</script>

<style lang="scss" scoped>
.labeled-status-badge {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
}

.labeled-status-badge__label {
  color: #6c7581;
  font-weight: 600;
}

.labeled-status-badge__value {
  font-weight: 600;
  font-size: 0.72rem;
  padding: 0.3rem 0.65rem;
}

.labeled-status-badge__value--success {
  background-color: #eaf6ee;
  color: #1f7a3a;
}

.labeled-status-badge__value--warning {
  background-color: #fdf6e3;
  color: #8a6a16;
}

.labeled-status-badge__value--danger {
  background-color: #fdecee;
  color: #a3242e;
}

.labeled-status-badge__value--secondary {
  background-color: #eceef1;
  color: #495057;
}
</style>
